const initialState = {
  text_messages: [],
};

const textMessagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'ADD_TEXT_MESSAGE': {
      return [action.textMessage, ...state];
    }
    case 'UPDATE_TEXT_MESSAGES': {
      return [action.textMessages];
    }
    default:
      return state;
  }
};

export default textMessagesReducer;
